<nav-bar *ngIf="autenticado" titulo="PORTAL FORNECEDOR" (logoutEvent)="logout($event)" [iconeNotificacoes]="false"
    [botaoPainelAplicacoes]="false"></nav-bar>
<router-outlet *ngIf="!autenticado"></router-outlet>
<menu-lateral *ngIf="autenticado" [itensMenu]="menuItens"></menu-lateral>